/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorInquiryDto } from '../../models/update-vendor-inquiry-dto';
import { VendorInquiryDto } from '../../models/vendor-inquiry-dto';

export interface VendorInquiryControllerAnswer$Params {
  id: string;
      body: UpdateVendorInquiryDto
}

export function vendorInquiryControllerAnswer(http: HttpClient, rootUrl: string, params: VendorInquiryControllerAnswer$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, vendorInquiryControllerAnswer.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorInquiryDto>;
    })
  );
}

vendorInquiryControllerAnswer.PATH = '/api/v1/vendorInquiry/{id}/answer';
